import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, CardBody, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { getActiveNetworkInquiriesViewDetails } from "../../../store/Sales/actions";
import { useSelector } from "react-redux";
import ViewDetailsSkeleton from "../skeleton/viewDetailsSkeleton";
import { GET_ALL_COUNTRY_DATA, GET_COMMODITY_DATA } from "../../../store/Global/actiontype";
import { getAllIncoTerms } from "../../../store/InstantRate/actions";
import { getCompanyStateData } from "../../../store/Settings/actions";
import Select from 'react-select';
import { optionCustomerDocumentType } from "../../../common/data/parties";


const ViewDetails = ({ viewDetailsType, inquirieType, isOpen, toggle, inquirieId, bookingId = null }) => {

    const { inquiry_data_loader, activeQuotationsViewDetails } = useSelector((state) => state?.sales);
    const { cargoType_data, container_data, UOM_weight_data, currency_data, commodity_data } = useSelector((state) => state?.globalReducer);
    const { settings_companydetails_data, settings_companyCity_data, tenant_info, settings_companyState_data, settings_companyCountry_data, settings_companyPincode_data } = useSelector((state) => state?.settings);
    const { incoterm } = useSelector((state) => state.instantRate);
    const { customer_data } = useSelector((state) => state?.customer);
    const [bookingAccountDetails, setBookingAccountDetails] = useState();
    const [customerInfo, setCustomerInfo] = useState();
    const [commodityValue, setCommodityValue] = useState({});
    const [activeTab, setActiveTab] = useState("cargo");
    const [documentType, setDocumentType] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: GET_COMMODITY_DATA });
        //dispatch({ type: GET_ALL_COUNTRY_DATA });
        dispatch(getAllIncoTerms());
        if (inquirieId !== '' && inquirieId !== undefined) {
            let url = '?inquiryId=' + inquirieId + (bookingId ? `&bookingId=${bookingId}` : '');
            dispatch(getActiveNetworkInquiriesViewDetails(url));
        }
    }, [inquirieId, bookingId])

    useEffect(() => {
        setCommodityValue({});
        setBookingAccountDetails({});
        setCustomerInfo({});
        if (activeQuotationsViewDetails?.tenantBookingSummary?.billingAcctId === null) {
            setBookingAccountDetails(tenant_info);
        } else {
            console.log(customer_data?.content?.find(item => item?.id === activeQuotationsViewDetails?.tenantBookingSummary?.billingAcctId), "Custmer Info");
            setCustomerInfo(customer_data?.content?.find(item => item?.id === activeQuotationsViewDetails?.tenantBookingSummary?.billingAcctId));
        }
        if (activeQuotationsViewDetails?.commodityId && commodity_data?.length > 0) {
            //console.log(commodity_data?.find(item => Number(item?.id) === Number(activeQuotationsViewDetails?.commodityId)), "commodity_Item")
            setCommodityValue(commodity_data?.find(item => Number(item?.id) === Number(activeQuotationsViewDetails?.commodityId)));
        }
    }, [activeQuotationsViewDetails, commodity_data]);



    const getAddressInfo = (infoType) => {
        if (infoType === "shipper") {
            if (activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails[0]?.addressType === "SHIPPER" && activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails[0]?.cityId) {
                //console.log(activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails, "tenantBookingDetails")
                dispatch(getCompanyStateData({ cityId: activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails[0]?.cityId }));
            }
        }
        if (infoType === "consignee") {
            if (activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails[1]?.addressType === "CONSIGNEE" && activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails[1]?.cityId) {
                //console.log(activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails, "tenantBookingDetails")
                dispatch(getCompanyStateData({ cityId: activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails[1]?.cityId }));
            }
        }
    }

    const uomLabels = {
        6: 'KG',
        7: 'MT',
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '38px',
            borderRadius: '6px',
            borderColor: state.isFocused ? '#2684FF' : '#ced4da',
            boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999, // Important for stacking above modal
        }),
    };

    return (
        <>
        <style>
            {`
                .modal-title {
                    width: 100%;
                }
            `}
        </style>
            <Modal isOpen={isOpen} toggle={toggle} size="xl" centered scrollable={true}>
                <ModalHeader>
                    {/* Tab Navigation */}
                    <div style={{width: '100%'}}>
                        <h4>Inquirie Id: {inquirieId}</h4>
                        {activeQuotationsViewDetails?.isMarketPlace === true && <h5>Shipper Name : {activeQuotationsViewDetails?.shipperTenantName || '-'}</h5>}
                        {activeQuotationsViewDetails?.isMarketPlace === false && <h5>Customer Name : {activeQuotationsViewDetails?.customerName || '-'}</h5>}
                        <hr />
                    </div>
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "cargo" ? "active" : ""}`}
                                onClick={() => setActiveTab("cargo")}
                            >
                                Cargo Details
                            </button>
                        </li>
                        {bookingId && (
                            <>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "billing" ? "active" : ""}`}
                                        onClick={() => setActiveTab("billing")}
                                    >
                                        Billing Details
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "shipper" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("shipper"); getAddressInfo("shipper"); }}
                                    >
                                        Shipper Details
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "consignee" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("consignee"); getAddressInfo("consignee"); }}
                                    >
                                        Consignee Details
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "document" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("document"); }}
                                    >
                                        Documents
                                    </button>
                                </li>
                            </>
                        )}

                    </ul>
                </ModalHeader>
                <ModalBody>
                    {/* Tab Content */}
                    {activeTab === "cargo" && (
                        <>
                            {inquiry_data_loader && (
                                <ViewDetailsSkeleton />
                            )}
                            {!inquiry_data_loader && (
                                <div className="container border p-4 mt-4">
                                    {/* Row 1 */}
                                    {bookingId === null && (
                                        <div className="row mb-3">
                                            <div className="col-md-2 fw-bold">EXIM</div>
                                            <div className="col-md-10">{activeQuotationsViewDetails?.movementType || '-'}</div>
                                        </div>
                                    )}


                                    {/* Row 2 */}
                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Cargo Type</div>
                                        <div className="col-md-10">{cargoType_data.find(item => String(item?.id) === String(activeQuotationsViewDetails?.inquiryField?.cargoTypeId))?.label || 'N/A'}</div>
                                    </div>
                                    {/* Row 3: Container Details */}
                                    {inquirieType === 'OCEAN_FCL' && (
                                        <div className="row mb-3">
                                            <div className="col-md-2 fw-bold">Container Details</div>
                                            <div className="col-md-10">
                                                <div className="border p-3">
                                                    <div className="row fw-semibold text-center mb-2">
                                                        <div className="coactiveQuotationsViewDetailsl-md-4">Container Type</div>
                                                        <div className="col-md-4">No of Units</div>
                                                        <div className="col-md-4">Weight/Unit</div>
                                                    </div>
                                                    {activeQuotationsViewDetails?.inquiryField?.containerDetails?.map((item, index) => (
                                                        <div className="row mb-2" key={index}>
                                                            <div className="col-md-4">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={container_data.find(obj => String(obj?.id) === String(item?.id))?.label || 'N/A'}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={item?.noOfUnits}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={`${item?.weight} ${uomLabels[item?.cargoWeightUOMId]}`}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {inquirieType === 'AIR' && (
                                        <div className="row mb-3">
                                            <div className="col-md-2 fw-bold">Shipment Details</div>
                                            <div className="col-md-10">
                                                <div className="border p-3">
                                                    <div className="row fw-semibold text-center mb-2">
                                                        <div className="col-md-2 text-start">No Of Unit</div>
                                                        <div className="col-md-2 text-start">Units Per Price</div>
                                                        <div className="col-md-8 text-start">Dimensions (L×W×H per unit)</div>
                                                    </div>
                                                    {activeQuotationsViewDetails?.inquiryField?.shipmentDetails?.map((item, index) => (
                                                        <div className="row mb-2" key={index}>
                                                            <div className="col-md-2">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={item?.noOfUnits || 'N/A'}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-md-2">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={`${item?.weightPerUnit || '0'} ${item?.weightUOM || 'KG'}`}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="d-flex align-items-center me-3" style={{ width: "90px" }}>
                                                                        <span className="me-1 fw-bold" style={{ fontSize: "12px", width: "15px" }}>L:</span>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={item?.length}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                    <div className="d-flex align-items-center me-3" style={{ width: "90px" }}>
                                                                        <span className="me-1 fw-bold" style={{ fontSize: "12px", width: "15px" }}>W:</span>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={item?.width}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                    <div className="d-flex align-items-center me-3" style={{ width: "90px" }}>
                                                                        <span className="me-1 fw-bold" style={{ fontSize: "12px", width: "15px" }}>H:</span>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={item?.height}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                    <div style={{ width: "60px" }}>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm"
                                                                            value={item?.uom || "CM"}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Cargo Value</div>
                                        <div className="col-md-10">
                                            <div className="row fw-semibold">
                                                <div className="col-md-9">{activeQuotationsViewDetails?.cargoValue
                                                    ? `${activeQuotationsViewDetails.cargoValue} (USD)`
                                                    : '-'}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 4: Commodity */}
                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Commodity</div>
                                        <div className="col-md-10">
                                            <div className="row fw-semibold">
                                                <div className="col-md-9">{commodityValue?.label || '-'}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 5: Incoterms */}
                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Incoterms</div>
                                        <div className="col-md-10">{incoterm.find(i => String(i?.value) === String(activeQuotationsViewDetails?.incotermId))?.label || 'N/A'}</div>
                                    </div>

                                    {/* Row 6: Customs Handling */}
                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Customs At Origin</div>
                                        <div className="col-md-10">{activeQuotationsViewDetails?.isCustomsAtOrigin ? 'Required' : 'Not Required'}</div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Customs At Destination</div>
                                        <div className="col-md-10">{activeQuotationsViewDetails?.isCustomsAtDestination ? 'Required' : 'Not Required'}</div>
                                    </div>

                                    {/* Row 7: Insurance */}
                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Insurance</div>
                                        <div className="col-md-10">{activeQuotationsViewDetails?.isInsuranceRequired ? 'Required' : 'Not Required'}</div>
                                    </div>

                                    {/* Row 8: Special Instruction */}
                                    <div className="row mb-3">
                                        <div className="col-md-2 fw-bold">Special Instruction</div>
                                        <div className="col-md-10">
                                            {activeQuotationsViewDetails?.remarks || 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    {activeTab === "billing" && (
                        <div>
                            <div className="card mb-4 shadow" style={{ borderRadius: "12px", border: "none" }}>
                                <div className="card-header bg-success text-white d-flex align-items-center" style={{ borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
                                    <span style={{ fontSize: "1.5rem", marginRight: "10px" }}>📦</span>
                                    <span className="fw-bold fs-5">Billing Account</span>
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="mb-2">
                                                <strong>Name:</strong> {bookingAccountDetails.firstName || "-"} {bookingAccountDetails.lastName || customerInfo?.name || ""}
                                            </div>
                                            <div className="mb-2">
                                                <strong>
                                                    <span style={{ verticalAlign: "middle" }}>{/* address icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M8 0a5 5 0 0 0-5 5c0 4.25 5 11 5 11s5-6.75 5-11a5 5 0 0 0-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" /></svg></span>
                                                    Address:
                                                </strong> {bookingAccountDetails.address || customerInfo?.address || "-"}
                                            </div>
                                            <div className="mb-2">
                                                <strong>
                                                    <span style={{ verticalAlign: "middle" }}>{/* email icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.117V5.383zm-.034 6.434-4.857-3.02L8 9.583l-1.109-.786-4.857 3.02A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.183zM1 11.117l4.708-2.909L1 5.383v5.734z" /></svg></span>
                                                    Email:
                                                </strong> {bookingAccountDetails.email || customerInfo?.contactEmail || "-"}
                                            </div>
                                            <div className="mb-2">
                                                <strong>
                                                    <span style={{ verticalAlign: "middle" }}>{/* phone icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M3.654 1.328a.678.678 0 0 1 .252-.252c.2-.12.45-.12.65 0l2.29 1.32c.2.115.3.34.25.55l-.7 2.45a.678.678 0 0 1-.252.252c-.2.12-.45.12-.65 0l-1.32-.76a11.72 11.72 0 0 0 5.516 5.516l.76-1.32c.12-.2.35-.25.55-.25l2.45.7c.21.05.435.15.55.25l1.32 2.29c.12.2.12.45 0 .65a.678.678 0 0 1-.252.252c-1.885 1.12-4.13 1.12-6.015 0C2.534 10.13 2.534 7.885 3.654 6z" /></svg></span>
                                                    Phone:
                                                </strong> {bookingAccountDetails.contactNumber || customerInfo?.contactNo || "-"}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-2"><strong>City ID:</strong> {bookingAccountDetails?.city?.cityName || customerInfo?.city?.cityName || "-"}</div>
                                            <div className="mb-2"><strong>State ID:</strong> {bookingAccountDetails?.state?.stateName || customerInfo?.state?.stateName || "-"}</div>
                                            <div className="mb-2"><strong>Country ID:</strong> {bookingAccountDetails?.country?.countryName || customerInfo?.country?.countryName || "-"}</div>
                                            <div className="mb-2"><strong>Zipcode:</strong> {bookingAccountDetails?.pinCode?.pin || customerInfo?.pinCode?.pin || "-"}</div>
                                        </div>Add commentMore actions
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === "shipper" && (
                        <div>
                            {activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails?.filter(
                                d => d.addressType === "SHIPPER"
                            ).map((shipper, idx) => (
                                <div key={idx} className="card mb-4 shadow" style={{ borderRadius: "12px", border: "none" }}>
                                    <div className="card-header bg-primary text-white d-flex align-items-center" style={{ borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
                                        <span style={{ fontSize: "1.5rem", marginRight: "10px" }}>🚢</span>
                                        <span className="fw-bold fs-5">Shipper #{idx + 1}</span>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="mb-2">
                                                    <strong>Name:</strong> {shipper.firstName || "-"} {shipper.lastName || ""}
                                                </div>
                                                <div className="mb-2">
                                                    <strong>
                                                        <span style={{ verticalAlign: "middle" }}>{/* address icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M8 0a5 5 0 0 0-5 5c0 4.25 5 11 5 11s5-6.75 5-11a5 5 0 0 0-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" /></svg></span>
                                                        Address:
                                                    </strong> {shipper.address || "-"}
                                                </div>
                                                <div className="mb-2">
                                                    <strong>
                                                        <span style={{ verticalAlign: "middle" }}>{/* email icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.117V5.383zm-.034 6.434-4.857-3.02L8 9.583l-1.109-.786-4.857 3.02A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.183zM1 11.117l4.708-2.909L1 5.383v5.734z" /></svg></span>
                                                        Email:
                                                    </strong> {shipper.emailId || "-"}
                                                </div>
                                                <div className="mb-2">
                                                    <strong>
                                                        <span style={{ verticalAlign: "middle" }}>{/* phone icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M3.654 1.328a.678.678 0 0 1 .252-.252c.2-.12.45-.12.65 0l2.29 1.32c.2.115.3.34.25.55l-.7 2.45a.678.678 0 0 1-.252.252c-.2.12-.45.12-.65 0l-1.32-.76a11.72 11.72 0 0 0 5.516 5.516l.76-1.32c.12-.2.35-.25.55-.25l2.45.7c.21.05.435.15.55.25l1.32 2.29c.12.2.12.45 0 .65a.678.678 0 0 1-.252.252c-1.885 1.12-4.13 1.12-6.015 0C2.534 10.13 2.534 7.885 3.654 6z" /></svg></span>
                                                        Phone:
                                                    </strong> {shipper.phoneNumber || "-"}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-2"><strong>City ID:</strong> {settings_companyCity_data?.content?.find(item => item.id === shipper.cityId)?.cityName || "-"}</div>
                                                <div className="mb-2"><strong>State ID:</strong> {settings_companyState_data?.content?.[0]?.stateName || "-"}</div>
                                                <div className="mb-2"><strong>Country ID:</strong> {settings_companyCity_data?.content?.find(item => item.id === shipper.cityId)?.country?.countryName || "-"}</div>
                                                <div className="mb-2"><strong>Zipcode:</strong> {shipper.zipcodeId || "-"}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {(!activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails ||
                                !activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails?.some(d => d.addressType === "SHIPPER")) && (
                                    <div className="alert alert-warning">No shipper details available.</div>
                                )}
                        </div>
                    )}
                    {activeTab === "consignee" && (
                        <div>
                            {activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails?.filter(
                                d => d.addressType === "CONSIGNEE"
                            ).map((consignee, idx) => (
                                <div key={idx} className="card mb-4 shadow" style={{ borderRadius: "12px", border: "none" }}>
                                    <div className="card-header bg-success text-white d-flex align-items-center" style={{ borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
                                        <span style={{ fontSize: "1.5rem", marginRight: "10px" }}>📦</span>
                                        <span className="fw-bold fs-5">Consignee #{idx + 1}</span>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="mb-2">
                                                    <strong>Name:</strong> {consignee.firstName || "-"} {consignee.lastName || ""}
                                                </div>
                                                <div className="mb-2">
                                                    <strong>
                                                        <span style={{ verticalAlign: "middle" }}>{/* address icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M8 0a5 5 0 0 0-5 5c0 4.25 5 11 5 11s5-6.75 5-11a5 5 0 0 0-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" /></svg></span>
                                                        Address:
                                                    </strong> {consignee.address || "-"}
                                                </div>
                                                <div className="mb-2">
                                                    <strong>
                                                        <span style={{ verticalAlign: "middle" }}>{/* email icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.117V5.383zm-.034 6.434-4.857-3.02L8 9.583l-1.109-.786-4.857 3.02A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.183zM1 11.117l4.708-2.909L1 5.383v5.734z" /></svg></span>
                                                        Email:
                                                    </strong> {consignee.emailId || "-"}
                                                </div>
                                                <div className="mb-2">
                                                    <strong>
                                                        <span style={{ verticalAlign: "middle" }}>{/* phone icon */}<svg width="16" height="16" fill="currentColor" style={{ marginRight: "4px" }}><path d="M3.654 1.328a.678.678 0 0 1 .252-.252c.2-.12.45-.12.65 0l2.29 1.32c.2.115.3.34.25.55l-.7 2.45a.678.678 0 0 1-.252.252c-.2.12-.45.12-.65 0l-1.32-.76a11.72 11.72 0 0 0 5.516 5.516l.76-1.32c.12-.2.35-.25.55-.25l2.45.7c.21.05.435.15.55.25l1.32 2.29c.12.2.12.45 0 .65a.678.678 0 0 1-.252.252c-1.885 1.12-4.13 1.12-6.015 0C2.534 10.13 2.534 7.885 3.654 6z" /></svg></span>
                                                        Phone:
                                                    </strong> {consignee.phoneNumber || "-"}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-2"><strong>City ID:</strong> {settings_companyCity_data?.content?.find(item => item.id === consignee.cityId)?.cityName || "-"}</div>
                                                <div className="mb-2"><strong>State ID:</strong> {settings_companyState_data?.content?.[0]?.stateName || "-"}</div>
                                                <div className="mb-2"><strong>Country ID:</strong> {settings_companyCity_data?.content?.find(item => item.id === consignee.cityId)?.country?.countryName || "-"}</div>
                                                <div className="mb-2"><strong>Zipcode:</strong> {consignee.zipcodeId || "-"}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {(!activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails ||
                                !activeQuotationsViewDetails?.tenantBookingSummary?.tenantBookingDetails?.some(d => d.addressType === "CONSIGNEE")) && (
                                    <div className="alert alert-warning">No consignee details available.</div>
                                )}
                        </div>
                    )}
                    {activeTab === 'document' && (
                        <div className='row'>
                            <div className="col-12 col-md-6">
                                <div className="mb-3" style={{ position: 'relative', zIndex: 1 }}>
                                    <label className="form-label">Document Type<span className='required_star'>*</span></label>
                                    <Select
                                        name={`documentType`}
                                        value={documentType}
                                        onChange={(e) => {
                                            setDocumentType(e);
                                            //documentsFormik.setFieldValue(`document[${index}].documentType`, e.value);
                                        }}
                                        placeholder="Select Document Type"
                                        options={optionCustomerDocumentType}
                                        styles={customStyles}
                                        menuPortalTarget={document.body}
                                        menuPosition="absolute"
                                        menuShouldBlockScroll={true}
                                        classNamePrefix="select2-selection form-select"
                                    />

                                </div>
                            </div>
                            <div className="col-12 col-md-5">
                                <div className="mb-3">
                                    <label className="form-label">Upload Documents<span className='required_star'>*</span></label>
                                    <Input
                                        type="file"
                                        name={`uploadDocument`}
                                        // onChange={(e) => { documentUploadHandler(e, `document[${index}].uploadDocument`) }}
                                        className="form-control"
                                        placeholder=""
                                    />
                                </div>
                            </div>
                            <div className='col-12 col-md-1 text-end'>
                                {/* Show Document List*/}
                            </div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}


export default ViewDetails;
